export const validateStartDate = (startDate, finishDate): { isError: boolean, message: string } => {
    if (!startDate || !finishDate) {
        return {
            isError: false,
            message: ""
        }
    }
    const startDateTime = new Date(startDate).getTime();
    const finishDateTime = new Date(finishDate).getTime();

    if (startDateTime > finishDateTime) {
        return {
            isError: true,
            message: "Start date cannot be later than finish date"
        }
    }

    if (finishDateTime === startDateTime) {
        return {
            isError: true,
            message: "Dates can't be the same"
        }
    }

    return {
        isError: false,
        message: ""
    }
}
export const valdiateFinishDate = (startDate, finishDate): { isError: boolean, message: string } => {
    
    if (!startDate || !finishDate) {
        return {
            isError: false,
            message: ""
        }
    }
    
    const startDateTime = new Date(startDate).getTime();
    const finishDateTime = new Date(finishDate).getTime();

    if (startDateTime > finishDateTime) {
        return {
            isError: true,
            message: "Finish date cannot be earlier than Start date"
        }
    }

    if (finishDateTime === startDateTime) {
        return {
            isError: true,
            message: "Dates can't be the same"
        }
    }

    return {
        isError: false,
        message: ""
    }
}